define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/matrix/ColumnVector"
], function(declare,_,ColumnVector) {

	return declare(ColumnVector, {
		columnPath: "Child:Colorways",
		
		_filterNodes : function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: filter nodes by index of 
			var columnIndex = ctx.getParent().Colorways.indexOf(spec.columnUrl);

			// filter the MaterialPlanPlacement nodes by seasons from the theme && main material = true
			var filteredNodes = _.filter(nodes, function(node) {
				return nodes.length > columnIndex && nodes[columnIndex] == node;
			});
			
			if (filteredNodes.length > 1) {
				return [filteredNodes[0]];
			}
			
			return filteredNodes;
		},
		
		/**
		 * @override
		 * Return the given node (size range)
		 */
		_getRowNodes: function(ctx, qr, c, node) {
			var nodes = ctx.cache.getNodes(node.ColorwaysColor);
			// filter nodes for this cell
			return this._filterNodes(ctx, c, nodes);
		}

	});
});